import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.deliveries')
  .filter('serviceItemsCount', serviceItemsCount);

/* @ngInject */
function serviceItemsCount() {
  return function (items) {
    return _.reduce(items, (sum, i) => {
      return sum + (i.count || 0);
    }, 0) || undefined;
  };
}
